import * as Scrivito from "scrivito";

const SpaceWidget = Scrivito.provideWidgetClass("SpaceWidget", {
  attributes: {
    fixedSize: ["enum", { values: ["1rem", "2rem", "3rem"] }],
    customSize: "string",
    // old attribute kept for backward compatibility
    size: "float",
  },
});

export default SpaceWidget;
